module.exports = __webpack_public_path__ + "media/images/athletes/2829-9b0b2fd580436635d6b743f2cab0ec91.png";